export function extractQueryParamsFromUrl(url: string): { [x: string]: string } | {} {
    const urlParams = url.match(/\w+=(\d+|\w+)/g);
    const mappedParams: { [x: string]: string } = {};
    urlParams?.forEach((param) => {
        mappedParams[param.split('=')[0].toString()] = param.split('=')[1];
    });

    return mappedParams;
}

export function extractQueryParamsFromUrlToArray(url: string): { [x: string]: string }[] | [] {
    const urlParams = url.match(/\w+=(\d+|\w+)/g);
    const mappedParams: { [x: string]: string }[] = [];
    urlParams?.forEach((param) => {
        const keyValue: { [x: string]: string } = {};
        keyValue[param.split('=')[0].toString()] = param.split('=')[1];
        mappedParams.push(keyValue);
    });

    return mappedParams;
}
